var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.show
    ? _c("div", { staticClass: "spin" }, [
        _c(
          "div",
          { staticClass: "ring", staticStyle: { "font-size": "160%" } },
          [
            _c("v-progress-circular", {
              attrs: {
                rotate: 360,
                size: 200,
                width: 15,
                value: _vm.value,
                color: "light-blue",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function () {
                      return [_c("b", [_vm._v(_vm._s(_vm.value) + " %")])]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1486533419
              ),
            }),
          ],
          1
        ),
        _vm.message.length > 0
          ? _c("div", { staticClass: "ring", staticStyle: { top: "65%" } }, [
              _c("b", [_vm._v(_vm._s(_vm.message))]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }